import { createAuthGuard, createInitialAuthRestoreController } from './authGuard';
import { createApiOnlyGuard } from './apiOnlyGuard';
import { createChromeAfterEachGuard, createChromeBeforeEachGuard } from './chromeGuard';
import { createOnboardingGuard } from './onboardingGuard';

export function setupRouterGuards({ router, authStore, displayStore, authRestoreOptions = {} }) {
  const authRestore = createInitialAuthRestoreController({
    router,
    authStore,
    ...authRestoreOptions,
  });

  authRestore.start();

  router.beforeEach(createChromeBeforeEachGuard({ displayStore }));
  router.beforeEach(createAuthGuard({ authStore, authRestore }));
  router.beforeEach(createApiOnlyGuard({ authStore }));
  router.beforeEach(createOnboardingGuard({ authStore }));
  router.afterEach(createChromeAfterEachGuard({ authStore }));

  return { authRestore };
}
